import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

import SidebarAdmin from "./Utils/SidebarAdmin";
import ReadUsers from "./Resource/ReadUsers";

import "./Dashboard.css";
import { logout } from "../apis/backend";
import LogoutButton from "./LogoutButton";

export default function Registartion_List() {
  const navigate = useNavigate();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="dash-layout">
      {/* Sidebar */}
      <SidebarAdmin
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={() => setSidebarCollapsed((p) => !p)}
      />

      {/* Main Wrapper */}
      <div
        className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""
          }`}
      >
        {/* Header */}
        <header className="dash-header">
          <h1 className="dash-page-title">Registrations</h1>

          <div className="dash-user-profile">
            <div
              className="dash-profile-circle"
              onClick={() => setShowDropdown((p) => !p)}
            >
              <span>A</span>
            </div>

            {showDropdown && (
              <div className="dash-profile-dropdown">
                <LogoutButton />
              </div>
            )}
          </div>
        </header>

        {/* Page Content */}
        <div className="dash-content-body">
          <ReadUsers />
        </div>
      </div>
    </div>
  );
}
